export default __webpack_public_path__ + "static/media/5-gm-unachieved.891cbbb9.svg";